import React, { useEffect,useState } from "react";
import moment from 'moment/moment';
import useInterval from 'use-interval';
import { StyledEngineProvider } from "@mui/material/styles";
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/Button";
import { FormControlLabel, FormGroup, Switch, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import DeleteIcon from "@mui/icons-material/Delete";


export const FxLiveTimeBox = (props) => {
  const [size, setSize] = useState('10px');
  const [color, setColor] = useState("white");
  const [background, setBackground] = React.useState([]);

  useEffect(()=>{
    if(props.item.fxUiDashbItemAttrs){
      handleColorChange({target:{value:props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='color')?props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='color').attrVal:'white'}});
      handleSizeChange({target:{value:props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='size') ? parseInt(props.item.fxUiDashbItemAttrs.find(x=>x.attrName=='size').attrVal) : '10px'}});
    }
  },[]);
  
    // const [realTime, setRealTime] = useState(moment().format('YYYY/MM/DD HH:mm:ss'));
    const [realTime, setRealTime] = useState(moment().format('YYYY.MM.DD HH:mm'));
    
    useInterval(() => {
      // setRealTime(moment().format('YYYY/MM/DD HH:mm:ss'));
      setRealTime(moment().format('YYYY.MM.DD HH:mm'));
      // console.log("props.editable>>>>", JSON.stringify(props.editable) );
    }, 1000);


    const handleColorChange = (e) => { //컬러
      console.log("color  >>> ",e.target.value);
      setColor(e.target.value)
  }
    const handleSizeChange = (e) => { //크기
      setSize(e.target.value)
  }
    const handleSave = () => { //저장
      let currentData = [];
      currentData.push({uiNo:props.item.uiNo,attrName:'color',attrVal:color,attrType:'string'})
      currentData.push({uiNo:props.item.uiNo,attrName:'size',attrVal:size,attrType:'string'})
      props.save(currentData,props.item.uiNo,props.item.opId);
  }
  
  const removeItem = () => {
    props.removeItem(props.item.uiNo)
  }

    return (
      <StyledEngineProvider>
        <span style={{fontSize:size+'px', color:color, backgroundColor:background}}>
          {realTime}
        </span>  

        <div>
          {props.editable ? 
          <>
            <input style={{width:'100px'}} type="color" value={color} onChange={handleColorChange} /> 
            <TextField sx={{input:{color:"white",fontSize:"10px",padding:'none'}, margin:'5px', 
                        '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                        '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                        '.MuiSvgIcon-root ': {fill: "white !important",}}} type="number" value={size} onChange={handleSizeChange} />
                                                
            <Button variant={"contained"} onClick={handleSave}>SAVE</Button>
          </> : ''}
        </div>
      </StyledEngineProvider>



    )
};

